import '.de{outline:none;}.ssr-plugin'
import '.gk{max-width:100svw;}.ssr-plugin'
import '.d7{overflow:auto;}.ssr-plugin'
import '.gl{scrollbar-width:none;}.ssr-plugin'
import React from 'react'
import { styled, Style } from 'inlines'
import { Overlay, OverlayProps } from '../Overlay/index.js'
import { OverlayTrigger } from '../Overlay/OverlayTrigger.js'
import { OverlayContent } from '../Overlay/OverlayContent.js'
import { colors } from '../../tokens/colors.js'
import { shadows } from '../../utils/shadows.js'
import { radius } from '../../utils/radius.js'
import { useTheme } from '../../hooks/useTheme.js'

type SheetProps = {
  children?: React.ReactNode
  open?: boolean
  position?: OverlayProps['position']
  style?: Style
}

const Sheet = ({
  children,
  open = false,
  style,
  position = 'bottom-center',
}: SheetProps) => {
  const triggerElement = React.Children.toArray(children).find(
    (child) => React.isValidElement(child) && child.type === OverlayTrigger,
  )

  const sheetItems = React.Children.toArray(children).filter(
    (child) => !React.isValidElement(child) || child.type === OverlayContent,
  )

  const { theme } = useTheme()

  return (
    <Overlay
      position={position}
      scrollableParent
      open={open}
      style={{ maxWidth: 600, ...style }}
    >
      <Overlay.Trigger>{triggerElement}</Overlay.Trigger>
      <Overlay.Content>
        <styled.div className="de gk d7 gl"
          style={{
            borderRadius: radius[20],
            background: colors.neutralInverted100,
            boxShadow: `inset 0 0 0 1px ${colors.neutral10}, ${shadows.popoverLarge}`,
            ...(theme === 'dark' && {
              background: colors.neutral10,
            }),
          }}
        >
          {sheetItems}
        </styled.div>
      </Overlay.Content>
    </Overlay>
  )
}

Sheet.Trigger = OverlayTrigger
Sheet.Content = OverlayContent
Sheet.Close = Overlay.Close
Sheet.CloseAll = Overlay.CloseAll

export { Sheet }
